<main>
  <router-outlet />
</main>
<!-- data-bs-theme="light" -->
